import cn from 'classnames';
import React, {forwardRef, useId} from 'react';

import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {twx} from '@/utils/tailwindUtils';

import InputComponent from './InputComponent';

// eslint-disable-next-line react/display-name
const RadioButtonChildComponent = forwardRef((props, ref) => {
    const {isDefaultMode, defaultDeviceName, deviceNameText, className, inputClassName, ...restProps} = props;
    const isMobile = useIsMobileLayout();
    const inputId = useId();

    return (
        <div className={twx('relative w-full items-start bg-cararra px-8 py-6 ml:bg-secondary ml:p-4', className)}>
            <div className='text-start'>
                <label
                    htmlFor={isDefaultMode ? undefined : inputId}
                    className={cn(
                        'block overflow-hidden text-ellipsis text-12 ml:text-16 ml:leading-15',
                        isMobile && isDefaultMode ? 'mb-3' : 'mb-4'
                    )}
                >
                    {deviceNameText}
                </label>
                {isDefaultMode ? (
                    <p id={inputId} className='w-full text-20'>
                        {defaultDeviceName}
                    </p>
                ) : (
                    <InputComponent className={inputClassName} {...restProps} ref={ref} id={inputId} />
                )}
            </div>
        </div>
    );
});

export default RadioButtonChildComponent;
